import axios from "axios";
import { applyInterceptors } from "../../utils/functions/applyInterceptors";

const {
  REACT_APP_NODE_ENV_KEY,
  REACT_APP_API_URL,
  REACT_APP_API_URL_DEVELOP,
  REACT_APP_ADMIN_API_URL,
  REACT_APP_ADMIN_API_URL_DEVELOP,
} = process.env;

const CURRENT_STUDIO_URL =
  REACT_APP_NODE_ENV_KEY === "production"
    ? REACT_APP_API_URL
    : REACT_APP_API_URL_DEVELOP;
const ADMIN_STUDIO_URL =
  REACT_APP_NODE_ENV_KEY === "production"
    ? REACT_APP_ADMIN_API_URL
    : REACT_APP_ADMIN_API_URL_DEVELOP;

// Safely read token at init; request interceptor will keep it updated
let token = "";
try {
  const raw = localStorage.getItem("authInfo");

  if (raw) {
    const data = JSON.parse(raw);
    token = data?.token || "";
  }
} catch (_) {
  token = "";
}

export const studioAxiosInstance = axios.create({
  baseURL: CURRENT_STUDIO_URL,
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
  },
  responseType: "json",
});

export const adminAxiosInstance = axios.create({
  baseURL: ADMIN_STUDIO_URL,
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
  },
  responseType: "json",
});

applyInterceptors(studioAxiosInstance);
applyInterceptors(adminAxiosInstance);
